import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './VideoBackgroundCarousel.css';

function VideoBackgroundCarousel() {
  return (


<div className="video-carousel-container">
      {/* YouTube Video Background */}

      <div class="overlay-text">
  Where Inclusion is a strength &amp; diversity is a force
</div>


<div className="video-container">
<iframe
  width="100%"
  height="100%"
  src="https://www.youtube.com/embed/HWy9LfKgBRw?start=0&end=30&autoplay=1&mute=1&loop=1&playlist=HWy9LfKgBRw&controls=0&showinfo=0&modestbranding=1"
  title="Background video"
  frameBorder="0"
  allow="autoplay; encrypted-media"
  allowFullScreen
></iframe>

</div>


      {/* Carousel Content Overlay */}
      <div className="carousel-overlay">
        <Carousel fade controls={false} indicators={false}>
          <Carousel.Item>
            <div className="carousel-caption">
              <h3>Welcome to Our School</h3>
              <p>Providing quality education since 1990.</p>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="carousel-caption">
              <h3>Innovative Learning</h3>
              <p>Empowering students for the future.</p>
            </div>
          </Carousel.Item>
          {/* Add more Carousel.Items as needed */}
        </Carousel>
      </div>












    </div>
  );
}

export default VideoBackgroundCarousel;
